import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getDecimalsFormats} from 'src/openapi/admin/apis/GetDecimalsFormatsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectDecimalFormats} from './services/dictionary-slice';

export const useDecimalFormats = () => {
    const apiDispatch = useAppDispatch();
    const decimalFormats = useSelector(selectDecimalFormats);

    const loadDecimalFormats = useCallback(() => {
        if (!decimalFormats.length) {
            apiDispatch(getDecimalsFormats());
        }
    }, [decimalFormats.length, apiDispatch]);

    return {decimalFormats, loadDecimalFormats};
};
